/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
export class ButtonHubService {
public buttonsReady: boolean = false;
private _previousBtnClicked = new Subject<any>();
/**
 * @return {?}
 */
public get previousBtnClicked(): Observable<any> {
        return this._previousBtnClicked.asObservable();
    }
private _nextBtnClicked = new Subject<any>();
/**
 * @return {?}
 */
public get nextBtnClicked(): Observable<any> {
        return this._nextBtnClicked.asObservable();
    }
private _dangerBtnClicked = new Subject<any>();
/**
 * @return {?}
 */
public get dangerBtnClicked(): Observable<any> {
        return this._dangerBtnClicked.asObservable();
    }
private _cancelBtnClicked = new Subject<any>();
/**
 * @return {?}
 */
public get cancelBtnClicked(): Observable<any> {
        return this._cancelBtnClicked.asObservable();
    }
private _finishBtnClicked = new Subject<any>();
/**
 * @return {?}
 */
public get finishBtnClicked(): Observable<any> {
        return this._finishBtnClicked.asObservable();
    }
private _customBtnClicked = new Subject<any>();
/**
 * @return {?}
 */
public get customBtnClicked(): Observable<any> {
        return this._customBtnClicked.asObservable();
    }
/**
 * @param {?} buttonType
 * @return {?}
 */
public buttonClicked(buttonType: string): void {
        if ("previous" === buttonType) {
            this._previousBtnClicked.next();
        } else if ("next" === buttonType) {
            this._nextBtnClicked.next();
        } else if ("finish" === buttonType) {
            this._finishBtnClicked.next();
        } else if ("danger" === buttonType) {
            this._dangerBtnClicked.next();
        } else if ("cancel" === buttonType) {
            this._cancelBtnClicked.next();
        } else {
            this._customBtnClicked.next(buttonType);
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ButtonHubService_tsickle_Closure_declarations() {
/** @type {?} */
ButtonHubService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ButtonHubService.ctorParameters;
/** @type {?} */
ButtonHubService.prototype.buttonsReady;
/** @type {?} */
ButtonHubService.prototype._previousBtnClicked;
/** @type {?} */
ButtonHubService.prototype._nextBtnClicked;
/** @type {?} */
ButtonHubService.prototype._dangerBtnClicked;
/** @type {?} */
ButtonHubService.prototype._cancelBtnClicked;
/** @type {?} */
ButtonHubService.prototype._finishBtnClicked;
/** @type {?} */
ButtonHubService.prototype._customBtnClicked;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
